<template>
    <div :class="[
        icon,
        sizeClass,
        icon === 'skeleton' ? 'skeleton-box' : ''
    ]" class="avatar"></div>
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        icon: {
            type: String,
        },
        large: {
            type: Boolean,
            default: false,
        },
        mini: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        sizeClass() {
            if (this.large)
                return 'large';

            if (this.mini)
                return 'mini';

            return 'small';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.avatar {
    &.large {
        @include icon(94px, 94px);

        &.equipment {
            background-image: url('icons/equipment_large.svg');
        }

        &.software {
            background-image: url('icons/software_large.svg');
        }

        &.services {
            background-image: url('icons/services_large.svg');
        }

        &.technology {
            background-image: url('icons/technology_large.svg');
        }

        &.complex {
            background-image: url('icons/complex_large.svg');
        }

        &.cart {
            background-image: url('icons/cart_large.svg');
        }

        &.cluster {
            background-image: url('icons/cluster_large.svg');
        }

        &.office {
            background-image: url('icons/office_large.svg');
        }

        &.cloud {
            background-image: url('icons/cloud_large.svg');
        }
    }

    &.small {
        @include icon(40px, 40px);
    }

    &.mini {
        @include icon(35px, 35px);
        border-radius: 100%;
    }

    &.equipment {
        background-image: url('icons/equipment_small.svg');
    }

    &.software {
        background-image: url('icons/software_small.svg');
    }

    &.services {
        background-image: url('icons/services_small.svg');
    }

    &.technology {
        background-image: url('icons/technology_small.svg');
    }

    &.complex {
        background-image: url('icons/complex_small.svg');
    }

    &.cart {
        background-image: url('icons/cart_small.svg');
    }

    &.office {
        background-image: url('icons/office_small.svg');
    }

    &.cloud,
    &.datacenter {
        background-image: url('icons/cloud_small.svg');
    }


    &.skeleton {
        border-radius: 100%;
    }
}
</style>
